import { render, staticRenderFns } from "./DiagnosticSelectPatient.vue?vue&type=template&id=283d5a5f&"
import script from "./DiagnosticSelectPatient.vue?vue&type=script&lang=js&"
export * from "./DiagnosticSelectPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports